import './navbar.scss';

import * as React from 'react';
import { MenuItem, Nav, Navbar as RBNavBar, NavDropdown, NavItem } from 'react-bootstrap';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { LinkContainer } from 'react-router-bootstrap';
import { IHistory } from 'src/interfaces'; 
import { logoutUser, parseJwt } from '../../../services/loginService'; 
declare var require: any;
const logo = require('../../../images/logo.png');

export interface INavbarProps {
    history?: IHistory;
    userId?: string;
    UniqueId?: string;
    Access_Level?: string;
    First_Name?: string;
}

export interface INavbarState {
    isSideNavbarOpen: boolean;
}

export class NavbarImpl extends React.PureComponent<INavbarProps, INavbarState> {
    constructor(props: INavbarProps) {
        super(props);
        this.state = { isSideNavbarOpen: false };
    }

    static defaultProps: INavbarProps;

    toggleSideNavbar = () => {
        this.setState({
            isSideNavbarOpen: !this.state.isSideNavbarOpen
        });
    }

    isSamePath = (path: string) => {
        const { history: { location: { pathname } } } = this.props;
        if (path === pathname) {
            return true;
        }
        return false;
    }

    render() {
        const { isSideNavbarOpen } = this.state;
        return (
            <RBNavBar className="nav-bar-container" collapseOnSelect>
                <RBNavBar.Header>
                    <RBNavBar.Brand>
                        <div
                            style={isSideNavbarOpen ? { width: '250px' } : { width: '0px' }}
                            id="mySidenav"
                            className="sidenav"
                        >
                            <a className="closebtn" onClick={this.toggleSideNavbar}>&times;</a>
                            <a href="#">Home</a>
                            <a href="#/inspections">Inspections</a>
                            <a href="#/summary-reports">Form Summary</a>
                            <a href="#/dashboard">Dashboard</a>
                            <a href="#/maintenance">Maintenance</a>
                            <a href="#/technical-support">Technical Support</a>
                        </div>
                        <span style={{ fontSize: '35px', color: 'black', lineHeight: '2', cursor: 'pointer' }}
                            onClick={this.toggleSideNavbar}>&#9776;</span>
                        <img className="nav-logo" src={logo} />
                    </RBNavBar.Brand>
                    <RBNavBar.Toggle />
                </RBNavBar.Header>
                <RBNavBar.Collapse>
                    <Nav pullRight>
                        <LinkContainer replace={this.isSamePath('/home')} to={`/home`}>
                            <NavItem eventKey={1}>Home</NavItem>
                        </LinkContainer>
                        <LinkContainer replace={this.isSamePath('/inspections')} to={`/inspections`}>
                            <NavItem eventKey={1}>Inspections</NavItem>
                        </LinkContainer>
                        <LinkContainer replace={this.isSamePath('/summary-reports')} to={`/summary-reports`}>
                            <NavItem eventKey={5}>Form Summary</NavItem>
                        </LinkContainer>
                        <NavDropdown eventKey={3} title="Reports" id="basic-nav-dropdown">
                            <LinkContainer replace={this.isSamePath('/reports/daily')} to={`/reports/daily`}>
                                <MenuItem eventKey={3.1}>
                                    Daily Reports
                                    </MenuItem>
                            </LinkContainer>
                            <LinkContainer replace={this.isSamePath('/reports/monthly')} to={`/reports/monthly`}>
                                <MenuItem eventKey={3.1}>
                                    Monthly Reports
                                    </MenuItem>
                            </LinkContainer>
                            <LinkContainer replace={this.isSamePath('/reports/quarterly')} to={`/reports/quarterly`}>
                                <MenuItem eventKey={3.1}>
                                    Quarterly Reports
                                    </MenuItem>
                            </LinkContainer>
                        </NavDropdown>
                        <LinkContainer replace={this.isSamePath('/dashboard')} to={`/dashboard`}>
                            <NavItem eventKey={6}>Dashboard</NavItem>
                        </LinkContainer>
                        <LinkContainer replace={this.isSamePath('/maintenance')} to={`/maintenance`}>
                            <NavItem eventKey={1}>Maintenance</NavItem>
                        </LinkContainer>
                        <NavDropdown eventKey={3} title={this.props.First_Name} id="basic-nav-dropdown">
                            <LinkContainer
                                replace={this.isSamePath(`/user-profile/${this.props.UniqueId}`)}
                                to={`/user-profile/${this.props.UniqueId}`}>
                                <MenuItem eventKey={3.1}>
                                    <i className="fa fa-user-circle-o"></i>
                                    &nbsp;
                                    User Profile
                                    </MenuItem>
                            </LinkContainer>
                            {this.props.Access_Level !== 'L1' ? '' :
                                <LinkContainer replace={this.isSamePath(`/user/list`)}
                                    to={`/user/list`}>
                                    <MenuItem eventKey={3.1}>
                                        <i className="fa fa-user-plus"></i>
                                        &nbsp;
                                        Users
                               </MenuItem>
                                </LinkContainer>}
                            <LinkContainer
                                replace={this.isSamePath('/user/update-password')}
                                to={`/user/update-password`}
                            >
                                <MenuItem eventKey={3.1}>
                                    <i className="fa fa-unlock"></i>
                                    &nbsp;
                                    Change Password
                                    </MenuItem>
                            </LinkContainer>
                            <LinkContainer replace={this.isSamePath('/technical-support')} to={`/technical-support`}>
                                <MenuItem eventKey={3.1}>
                                    <i style={{ fontSize: '22px' }} className="fa fa-question-circle-o"></i>
                                    &nbsp;
                                    Technical Support
                                    </MenuItem>
                            </LinkContainer>
                            <MenuItem divider />
                            <MenuItem onClick={() => logoutUser(this.props.history)} eventKey={3.3}>
                                <i className="fa fa-sign-out"></i>
                                &nbsp;
                                Sign Out
                            </MenuItem>
                        </NavDropdown>
                    </Nav>
                </RBNavBar.Collapse>
            </RBNavBar >
        );
    }
}

export function mapStateToProps(state) {
    let Access_Level = '';
    let First_Name = '';
    if (state.login.get('token')) {
        Access_Level = parseJwt(state.login.get('token')).Access_Level;
        First_Name = parseJwt(state.login.get('token')).First_Name;
    }
    return {
        userId: state.login.get('userId'),
        UniqueId: state.login.get('UniqueId'),
        Access_Level, First_Name
    };
}

export const Navbar = withRouter(connect<{}, {}, INavbarProps>(mapStateToProps)(NavbarImpl as any));



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/reusableComponents/Navbar/index.tsx